import { Component, Prop, Vue } from 'vue-property-decorator'
import { Nullable } from '@/shared/types/app.types'

@Component
export default class BillingCard extends Vue {
    @Prop({ type: String }) readonly title!: Nullable<string>
    @Prop({ type: String }) readonly titleIconClass!: Nullable<string>

    @Prop({ type: String }) readonly statusName!: Nullable<string>
    @Prop({ type: String }) readonly statusClass!: Nullable<string>

    @Prop({ type: String, default: 'accounting.field.client' }) readonly customerLabel!: Nullable<string>
    @Prop({ type: String, default: '-' }) readonly customerName!: Nullable<string>

    @Prop({ type: String, default: 'accounting.field.generationDate' }) readonly dateLabel!: Nullable<string>
    @Prop({ type: String, default: '-' }) readonly date!: Nullable<string>

    @Prop({ type: String, default: 'accounting.field.generationResponsible' }) readonly responsibleLabel!: Nullable<string>
    @Prop({ type: String, default: '-' }) readonly responsibleName!: Nullable<string>

    @Prop({ type: String, default: 'accounting.field.total' }) readonly totalLabel!: Nullable<string>
    @Prop({ type: Number, default: 0 }) readonly totalValue!: number

    @Prop({ type: String, default: 'accounting.field.unit' }) readonly accountingUnitLabel!: Nullable<string>
    @Prop({ type: String, default: '-' }) readonly accountingUnitName!: Nullable<string>
}
